// MapComponent.js
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Tooltip, Marker, useMap, useMapEvent } from 'react-leaflet';
import L from 'leaflet';
import pin from "../img/pin.png";
import pin_green from "../img/pin_green.png";
import pin_yellow from "../img/pin_yellow.png";
import pin_red from "../img/pin_red.png";
import pin_selected from "../img/pin_selected.png";



const MapResizeFix = () => {
    const map = useMap();
    useEffect(() => {
        setTimeout(() => {
            map.invalidateSize();
        }, 300); // Short delay to ensure map container is visible
    }, [map]);

    return null;
};

// Create a custom icon
const the_icon = L.icon({
    iconUrl: pin,   // Path to your custom marker image
    //shadowUrl: merchantIcon,   // Path to your custom marker image
    iconSize: [26, 32],         // Size of the icon
    shadowSize: [18, 18],         // Size of the icon
    shadowAnchor: [17, 36],         // Size of the icon
    iconAnchor: [12, 22],       // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -38],      // Point from which the popup should open relative to the iconAnchor
});


// Create a custom icon
const the_icon_green = L.icon({
    iconUrl: pin_green,   // Path to your custom marker image
    //shadowUrl: merchantIcon,   // Path to your custom marker image
    iconSize: [26, 32],         // Size of the icon
    shadowSize: [18, 18],         // Size of the icon
    shadowAnchor: [17, 36],         // Size of the icon
    iconAnchor: [12, 22],       // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -38],      // Point from which the popup should open relative to the iconAnchor
});

// Create a custom icon
const the_icon_yellow = L.icon({
    iconUrl: pin_yellow,   // Path to your custom marker image
    //shadowUrl: merchantIcon,   // Path to your custom marker image
    iconSize: [26, 32],         // Size of the icon
    shadowSize: [18, 18],         // Size of the icon
    shadowAnchor: [17, 36],         // Size of the icon
    iconAnchor: [12, 22],       // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -38],      // Point from which the popup should open relative to the iconAnchor
});

// Create a custom icon
const the_icon_red = L.icon({
    iconUrl: pin_red,   // Path to your custom marker image
    //shadowUrl: merchantIcon,   // Path to your custom marker image
    iconSize: [26, 32],         // Size of the icon
    shadowSize: [18, 18],         // Size of the icon
    shadowAnchor: [17, 36],         // Size of the icon
    iconAnchor: [12, 22],       // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -38],      // Point from which the popup should open relative to the iconAnchor
});

// Create a custom icon
const the_icon_selected = L.icon({
    iconUrl: pin_selected,   // Path to your custom marker image
    //shadowUrl: merchantIcon,   // Path to your custom marker image
    iconSize: [26, 32],         // Size of the icon
    shadowSize: [18, 18],         // Size of the icon
    shadowAnchor: [17, 36],         // Size of the icon
    iconAnchor: [12, 22],       // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -38],      // Point from which the popup should open relative to the iconAnchor
});



function MapClickHandler({ onClick }) {
  useMapEvent('click', (e) => {
    const { lat, lng } = e.latlng;
    onClick({ lat, lng });
  });

  return null; // this component doesn't render anything
}



const Map = ({ items, settingCoords, coordsCallback, defaultSelectedCoords=null, isMapClickable }) => {

  const center = [45.738, 7.322];
  var zoom = 12;

  const [selectedCoords , setSelectedCoords] = useState(null);


  const handleMapClick = (coords) => {
    console.log("AAAAHHH")
    console.log(isMapClickable)
    if(!isMapClickable) return;
    setSelectedCoords(coords);
    coordsCallback(coords)
  };

  useEffect(() => {

  }, [items]);


  useEffect(() => {
    setSelectedCoords(defaultSelectedCoords);
  }, [defaultSelectedCoords]);



    return (
        <div className="dynamic-table-map">

                <div style={{ height: "100%", width: "100%", overflow: 'hidden' }}>
                    <MapContainer
                        center={ center ? center : [45.738, 7.322]} zoom={zoom?zoom:5}
                        style={{ height: "100%", width: "100%" }} // Set the height and width of the map
                    >
                        <TileLayer
                            url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />

                        <MapResizeFix /> {/* <-- This ensures the map resizes properly */}
                        <MapClickHandler onClick={handleMapClick} />
                        {!settingCoords && items && items.map((position, index) => (

                            <Marker
                                key={index}
                                position={[position.latitude, position.longitude]}
                                icon={position.color==="green" ? the_icon_green : position.color==="yellow" ? the_icon_yellow : the_icon_red}   // Use the custom icon
                            >

                              <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent={false}>
                                <span>{position.name}</span>
                              </Tooltip>
                           </Marker>

                        ))}

                        {settingCoords && selectedCoords && (

                            <Marker
                                position={[selectedCoords.lat, selectedCoords.lng]}
                                icon={the_icon}   // Use the custom icon
                            >
                           </Marker>

                        )}


                    </MapContainer>
                </div>

        </div>
    );
};

export default Map;
